import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@beweegbaas/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { EditStudentForm } from "#/modules/school.students/components/edit-student-form";
import { getStudentModalData } from "#/modules/school.students/students.functions";

// Edit-student modal (portal's `students.overview.$id.modal`), rendered over the overview table.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/overview/$id/modal",
)({
  loader: ({ params }) => getStudentModalData({ data: { leerlingId: params.id } }),
  component: EditStudentModal,
});

function EditStudentModal() {
  const navigate = useNavigate();
  const { student, klassen } = Route.useLoaderData();
  const { locale, schoolyear, school } = Route.useParams();
  // Close back to the overview table (relative "../.." isn't a typed literal, so navigate absolute).
  const onClose = () =>
    navigate({
      to: "/$locale/{-$schoolyear}/$school/students/overview",
      params: { locale, schoolyear, school },
      search: (prev) => prev,
      replace: true,
    });

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) void onClose();
      }}
    >
      <DialogContent className="md:max-w-lg!" showCloseButton>
        <DialogHeader>
          <DialogTitle>Leerling bewerken</DialogTitle>
        </DialogHeader>
        <EditStudentForm
          student={student}
          klassen={klassen}
          onSuccess={onClose}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
